// Keyboard dismissal helper.
//
// The profile-setup form lives inside a transformed dialog; on iOS the native
// keyboard can cover the Complete button and there is no built-in way to
// dismiss it once a numeric field is focused (no return key on the numeric
// pad). This blurs the focused field — which dismisses the web keyboard —
// and also calls the Capacitor Keyboard plugin's hide() on native so the
// WKWebView keyboard slides away reliably. Best-effort and never throws.

export async function dismissKeyboard(): Promise<void> {
  // Blur first: this alone closes the soft keyboard on web and is the signal
  // iOS uses to release focus. document may be undefined under SSR/tests.
  try {
    const active = typeof document !== "undefined"
      ? (document.activeElement as HTMLElement | null)
      : null;
    active?.blur?.();
  } catch {
    /* no DOM (test/SSR); fall through to the native call. */
  }
  // Native belt-and-braces: WKWebView occasionally keeps the keyboard up
  // after a programmatic blur, so explicitly hide it on Capacitor runtimes.
  try {
    const { Keyboard } = await import("@capacitor/keyboard" as any);
    await Keyboard.hide();
  } catch {
    /* not a Capacitor runtime, or plugin missing: blur already handled it. */
  }
}
